module.exports = __webpack_public_path__ + "1.5.0-unryo/img/online-collector-1.c46a26a4.svg";